/**
 * Turns a raw field key (camelCase / PascalCase / snake_case) into a readable
 * label — the safety net for clarity-meter and revision fields whose key has no
 * translation (e.g. an AI-invented "neededEquipmentCount"). Prefer a real i18n
 * label; fall back to this so the user never sees a raw identifier.
 */
export function humanizeFieldLabel(key: string): string {
  if (!key) return '';
  const spaced = key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!spaced) return '';
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}
